import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultTextValues, textSchema } from '../../Text/model/TextSchema';

export const proceedingSchema = textSchema.extend({
  isbn: z.object({
    printCode: z.string().nullable(),
    onlineCode: z.string().nullable(),
  }),
  conference: identitySchema,
  bookName: z.string().nullable(),
  authors: z.array(authorSchema).min(1),
});

export const defaultProceedingValues: DefaultValues<ProceedingSchema> = {
  authors: [],
  bookName: '',
  isbn: {
    printCode: '',
    onlineCode: '',
  },
  ...defaultTextValues,
};

export type ProceedingSchema = z.infer<typeof proceedingSchema>;
